module.exports = __webpack_public_path__ + "media/images/admin/users-33f6e1c90cf46b0ecb381fc5226b1989.svg";